import classNames from 'classnames';
import React from 'react';

function Divider({ className = '' }) {
  return <div className={classNames('dropdown-divider tx-gray-300', className)} />;
}

export default Divider;
